import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { EditorDrawer } from '../editor-drawer/editor-drawer';
import { HistoryDrawer } from '../history-drawer/history-drawer';
import { SourceAuthService } from '../source-auth.service';
import { WorkspaceStore } from '../workspace-store';

@Component({
  selector: 'app-workspace',
  imports: [
    MatButtonModule, MatCardModule, MatIconModule, MatProgressSpinnerModule, MatToolbarModule,
    RouterLink, RouterLinkActive, RouterOutlet, TranslocoPipe, EditorDrawer, HistoryDrawer,
  ],
  templateUrl: './workspace-page.html',
  styleUrl: './workspace-page.scss',
})
export class WorkspacePage {
  readonly store = inject(WorkspaceStore);
  readonly auth = inject(SourceAuthService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly transloco = inject(TranslocoService);
  readonly activeLang = this.transloco.activeLang;
  readonly langs = ['pl', 'en'] as const;
  readonly sections = ['overview', 'compare', 'cross'] as const;
  readonly renderMode = this.store.renderMode;

  constructor() {
    this.store.load();
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      takeUntilDestroyed(),
    ).subscribe(() => this.store.dismissOverlays());
  }

  setLang(lang: 'pl' | 'en'): void {
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
    this.transloco.load(lang).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.transloco.setActiveLang(lang));
  }

  logout(): void {
    this.auth.logoutAll();
    void this.router.navigate(['/login']);
  }
}
